<template>
    <div>
        <h3 class="mb-2">{{ section.heading }}</h3>
        <div v-if="section.subheading" class="mb-2 italic">
            {{ section.subheading }}
        </div>
        <WysiwygContent :content="section.content" class="mb-6" />
    </div>
</template>

<script setup lang="ts">
import type { ArticleContentSectionType } from '#shared/types/ArticleContentSectionType';

defineProps<{
    section: ArticleContentSectionType;
}>();
</script>
